
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {extend} from './../../zviz2/zviz/functions';

//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.scale = 0;

    }

    render(renderer){
        super.render(renderer);
        
        this.scale += renderer.delta / 1000;
        if(this.scale > 1){
            this.scale -= 1;
        }

        this.update();
    }


}


let Blueprint = extend({
    properties: {
        style: { 
            position: 'absolute',
            zIndex: '3',
            backgroundColor: 'rgba(255,255,255,0.5)',
            top: '0px',
            bottom: '0px',
            left: '0px',
            right: '0px'
        },
        data: {
            size: 50,
            top: '50%',
            color: '#555555'
        }
    },
    children: [
        {
            type: Controller,
            properties:{
                style: {
                    backgroundColor: (ctrl) => (ctrl.parent.data.color),
                    width: (ctrl) => ( (ctrl.scale * ctrl.parent.data.size) + 'px' ),
                    height: (ctrl) => ( (ctrl.scale * ctrl.parent.data.size) + 'px' ),
                    borderRadius: (ctrl) => ( (ctrl.scale * 0.5 * ctrl.parent.data.size) + 'px' ),
                    position: 'absolute',
                    opacity: (ctrl) => ( (1 - ctrl.scale) ),
                    top: (ctrl) => (ctrl.parent.data.top),
                    left: '50%',
                    marginLeft: (ctrl) => ( (ctrl.scale * -0.5 * ctrl.parent.data.size) + 'px' ),
                    marginTop: (ctrl) => ( (ctrl.scale * -0.5 * ctrl.parent.data.size) + 'px' ),
                }
            }
        }
    ]
}, Group);


export default Blueprint;
export {Blueprint};
